module.exports = __webpack_public_path__ + "static/0a81acbfabf6bdcc5b9c9306f6f3dc4b28ae736676c42b05c848f5d9142b132d-3e3f6924aed2e07bd24ba6aa96c7cb15.jpeg";